import React, { useState, useEffect } from 'react'
import { Button, Input, Select, Table, Checkbox, Popconfirm } from 'antd'
import 'aos/dist/aos.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Modal } from 'antd'
import { Option } from 'antd/es/mentions'
import DataTable from 'react-data-table-component' // DataTable library
import {
  GetOrderAllotmentAllAllocatedData,
  GetOrderAllotmentAllocatedBundles,
  GetOrderAllotmentDropdownList,
  GetOrderAllotmentList,
  GetOrderAllotmentListById,
  GetOrderAllotmentStock,
  UpdateOrderAllotmentAllocationStatus,
  UpdateOrderAllotmentProductionStatus,
  UpdateOrderAllotmentStatus,
} from '../../AllAPI/SalesAPI/SalesApi'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
const OrderAllotment = () => {
  const [selectedId, setSelectedId] = useState('')
  const location = useLocation();
  const navigate = useNavigate();
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  }
  const [errors, setErrors] = useState({
    selectedId: '',
  })

  const goodTypesOptions = [
    { value: '1', label: 'F.T' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'Inch' },
  ]
  // const [allOrders, setAllOrders] = useState([]);
  // const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([])
  const [approvedItems, setApprovedItems] = useState(new Set())
  const [selectAll, setSelectAll] = useState(false)
  const [allOrders, setAllOrders] = useState([])
  const [allDropdownOrders, setAllDropdownOrders] = useState([])

  const [selectedOrder, setSelectedOrder] = useState(null)
  const [orderPass, setOrderPass] = useState(false)
  const [stockData, setStockData] = useState([])
  const [allocatedStock, setAllocatedStock] = useState([])
  const [allocated, setAllocated] = useState([])

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)
  const [isBulkSelecting, setIsBulkSelecting] = useState(false)
  const [selectedOrderItem, setSelectedOrderItem] = useState(null)
  const [selectedItemIds, setSelectedItemIds] = useState([])
    const [selectedItemIds1, setSelectedItemIds1] = useState([])

  const [selectedAllocationItem, setSelectedAllocationItem] = useState(null) // tracks the selected item for allocation
  const [allocatedItemsByName, setAllocatedItemsByName] = useState([]) // stores allocated data grouped by item name
  const [detailView, setDetailView] = useState(false)
  const [allocateBack, setAllocateBack] = useState(false) // tracks the selected item for allocation

  //======Search data from table===============
    const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
  
      const filtered = orderItems.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );

      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

//   // ==============Get  data================
//  // let isOrderAllotmentFetched = false
//   useEffect(() => {
//    // if (isOrderAllotmentFetched) return

//     fetchOrderAllotmentData()
//    // isOrderAllotmentFetched = true
//   }, [])
   useEffect(() => {
      fetchOrderAllotmentData(); // Always fetch on first mount
  
      if (location.state?.refresh) {
        console.log("Refetching after return from approval page");
        fetchOrderAllotmentData();
  
        // Remove refresh flag from location.state
        navigate(location.pathname, { replace: true, state: {} });
      }
    }, [location.state]);
  const fetchOrderAllotmentData = async () => {
    try {
      // const response = await axios.get("http://192.168.29.1getOrderAllotmentApprovalList16:8182/sales/OrderAllotmentApproval/getOrderAllotmentApprovalList",commonHeaders);
      const response = await axios.get(GetOrderAllotmentList, commonHeaders)

      setAllOrders(response.data) // assuming the API returns an array
    } catch (error) {
      console.error('Error fetching Order Allotment data:', error)
      toast.error('Error fetching Order Allotment data')
    }
  }

  //     const orderItemColumns = [
  //       {
  //         title: "Sr.No.",
  //         dataIndex: "",
  //         key: "index",
  //         render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //       },
  //       {
  //         title: "Item Entry Date",
  //         dataIndex: "itemEntryDate",
  //         key: "itemEntryDate",
  //         render: (date) => {
  //           if (!date) return "-";
  //           const [year, month, day] = date.split("-");
  //           return `${day}/${month}/${year}`;
  //         },
  //       },
  //       {
  //         title: "Alloy",
  //         dataIndex: "alloyname",
  //         key: "alloyname",
  //       },
  //       {
  //         title: "Item Name",
  //         dataIndex: "dieName",
  //         key: "dieName",
  //       },
  //       {
  //         title: "Temper",
  //         dataIndex: "temperName",
  //         key: "tetemperName",
  //       },
  //       {
  //         title: "Weight",
  //         dataIndex: "weight",
  //         key: "weight",
  //       },
  //       {
  //         title: "Length",
  //         dataIndex: "length",
  //         key: "length",
  //       },
  //       {
  //         title: "Pcs",
  //         dataIndex: "pcs",
  //         key: "pcs",
  //       },
  //       {
  //         title: "Qty",
  //         dataIndex: "qty",
  //         key: "qty",
  //       },
  //       // {
  //       //   title: "Allocation Done",
  //       //   dataIndex: "allocationDone",
  //       //   key: "allocationDone",
  //       // },
  //       {
  //         title: "Send to Production",
  //         dataIndex: "sendToProduction",
  //         key: "sendToProduction",
  //       },
  //       {
  //         title: "Allocated Pcs",
  //         dataIndex: "allocatedPcs",
  //         key: "allocatedPcs",
  //       },
  //       {
  //         title: "Allocated Qty",
  //         dataIndex: "allocatedQty",
  //         key: "allocatedQty",
  //       },
  //       {
  //            title:" Prod. Pcs",
  //           dataIndex: "productionPcs",
  //           key: "productionPcs",},

  //           {
  //              title:"Prod. Qty",
  //             dataIndex: "productionQty",
  //             key: "productionQty",},

  //       {
  //         title: "Select",
  //         key: "select",
  //         render: (text, record) => (
  //           <Checkbox
  //             checked={selectedItemIds.includes(record.id)}
  //             onChange={(e) => {
  //               const checked = e.target.checked;
  //               setSelectedItemIds((prev) =>
  //                 checked
  //                   ? [...prev, record.id]
  //                   : prev.filter((id) => id !== record.id)
  //               );
  //             }}
  //           />
  //         ),
  //       },

  //       {
  //         title: "Actions",
  //         key: "actions",
  //         render: (text, record) => (
  //           <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
  //             <Button
  //               type="primary"
  //               className="UpdateBtn"
  //               style={{ fontSize: "12px" }}
  //               onClick={() => {
  //   setSelectedOrderItem(record);
  //   setSelectedAllocationItem(record); // ← Add this line
  // }}
  //             >
  //               Allocation
  //             </Button>
  //             <Button
  //               type="default"
  //               className="SubmitBtn"
  //               style={{ fontSize: "12px" }}
  //               onClick={() => {
  //                 handleProduction([record.id]);
  //                 setSelectedOrderItem(record);

  //               }}
  //             >
  //               Production
  //             </Button>
  //           </div>
  //         ),
  //       }

  //     ];
  const orderItemColumns = [
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Item Entry Date',
      dataIndex: 'itemEntryDate',
      key: 'itemEntryDate',
      render: (date) => {
        if (!date) return '-'
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    },
    {
      title: 'Item Name',
      dataIndex: 'dieName',
      key: 'dieName',
    },
    // {
    //   title: "Item Details",
    //   key: "alloyTemper",
    //   render: (_, record) => (
    //     <div>
    //       <div><strong>Alloy:</strong> {record.alloyname}</div>
    //       <div><strong>Temper:</strong> {record.temperName}</div>
    //       <div><strong>Length:</strong> {record.length}</div>
    //       <div><strong>Weight:</strong> {record.weight}</div>
    //       <div><strong>Pcs:</strong> {record.pcs}</div>
    //       <div><strong>Quantity:</strong> {record.qty}</div>
    //     </div>
    //   ),
    // },
    {
      title: 'Alloy',
      dataIndex: 'alloyname',
      key: 'alloyname',
    },
    {
      title: 'Temp',
      dataIndex: 'temperName',
      key: 'temperName',
    },
    {
      title: 'Wt/R',
      dataIndex: 'weight',
      key: 'weight',
    },
//     {
//       title: 'Length',
//       dataIndex: 'length',
//       key: 'length',
//     },
//     {
//   title: 'Unit',
//   dataIndex: 'unit',
//   key: 'unit',
//   render: (unit) => {
//     const unitOption = goodTypesOptions.find((opt) => opt.value === String(unit));
//     return unitOption ? unitOption.label : '';
//   },
// },
 {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },


    {
      title: 'Pcs',
      dataIndex: 'pcs',
      key: 'pcs',
    },
    {
      title: 'Qty',
      dataIndex: 'qty',
      key: 'qty',
    },

    {
      title: 'Prod. Status',
      dataIndex: 'sendToProduction',
      key: 'sendToProduction',
    },
    {
      title: 'Allo. Pcs',
      dataIndex: 'allocatedPcs',
      key: 'allocatedPcs',
    },
    {
      title: 'Allo. Qty',
      dataIndex: 'allocatedQty',
      key: 'allocatedQty',
    },
    {
      title: 'Prod. Pcs',
      dataIndex: 'productionPcs',
      key: 'productionPcs',
    },
    {
      title: 'Prod. Qty',
      dataIndex: 'productionQty',
      key: 'productionQty',
    },
    {
      title: 'Pend.  Pcs',
      dataIndex: 'pendingOrderPcs',
      key: 'pendingOrderPcs',
    },
    {
      title: 'Pend. Qty',
      dataIndex: 'pendingOrderQty',
      key: 'pendingOrderQty',
    },
    {
      title: 'Select',
      key: 'select',
      render: (text, record) => (
        <Checkbox
          checked={selectedItemIds.includes(record.id)}
          onChange={(e) => {
            const checked = e.target.checked
            setSelectedItemIds((prev) =>
              checked
                ? [...prev, record.id]
                : prev.filter((id) => id !== record.id),
            )
          }}
        />
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <Button
            type="primary"
            className="UpdateBtn"
            style={{ fontSize: '12px' }}
            onClick={() => {
              // setSelectedOrderItem(record);
              // setSelectedAllocationItem(record);
              // fetchAllocatedBumdles(record);
              fetchStock(record)
              setDetailView(false)
              // setAllocateBack(true);
            }}
          >
            Allocation
          </Button>
          {/* <Button
            type="default"
            className="SubmitBtn"
            style={{ fontSize: '12px' }}
            onClick={() => {
              showConfirmationModal([record.id])
              //handleProduction([record.id]);
              setSelectedOrderItem(record)
              setDetailView(false)
            }}
          >
            Production
          </Button> */}

          
<Button
  type="default"
  className="SubmitBtn"
  style={{ fontSize: '12px' }}
  onClick={() => {
    showConfirmationModal([record.id]); // pass single ID
    setSelectedOrderItem(record);
    setDetailView(false);
  }}
>
  Production
</Button>


  
        </div>
      ),
    },
  ]


const allocatedColumns = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => index + 1,
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => {
      const descA = a.dieName || '';
      const descB = b.dieName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
    sorter: (a, b) => {
      const descA = a.alloyName || '';
      const descB = b.alloyName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
    sorter: (a, b) => {
      const descA = a.temperName || '';
      const descB = b.temperName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Wt/R',
    dataIndex: 'weightRange',
    key: 'weightRange',
    sorter: (a, b) => {
      const descA = a.weightRange || '';
      const descB = b.weightRange || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => {
      const descA = a.length ?? 0;
      const descB = b.length ?? 0;
      return descA - descB;
    },
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
   //     {
// //       title: 'Length',
// //       dataIndex: 'length',
// //       key: 'length',
// //     },
// //     {
// //   title: 'Unit',
// //   dataIndex: 'unit',
// //   key: 'unit',
// //   render: (unit) => {
// //     const unitOption = goodTypesOptions.find((opt) => opt.value === String(unit));
// //     return unitOption ? unitOption.label : '';
// //   },
// // }
// // ,
  {
    title: 'Pcs',
    dataIndex: 'pcs',
    key: 'pcs',
    sorter: (a, b) => {
      const descA = a.pcs ?? 0;
      const descB = b.pcs ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Qty',
    dataIndex: 'netWeight',
    key: 'netWeight',
    sorter: (a, b) => {
      const descA = a.netWeight ?? 0;
      const descB = b.netWeight ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Packing Id',
    dataIndex: 'packingId',
    key: 'packingId',
    sorter: (a, b) => {
      const descA = a.packingId || '';
      const descB = b.packingId || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Dispatch/Jobwork No.',
    dataIndex: 'dispatchNo',
    key: 'dispatchNo',
    sorter: (a, b) => {
      const descA = a.dispatchNo || '';
      const descB = b.dispatchNo || '';
      return descA.localeCompare(descB);
    },
  },
];

  const stockColumns = [
    // {
    //   title: 'Stock ID',
    //   dataIndex: 'stockId',
    //   key: 'stockId',
    // },
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => index + 1,
    },
     {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => {
      const descA = a.dieName || '';
      const descB = b.dieName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
    sorter: (a, b) => {
      const descA = a.alloyName || '';
      const descB = b.alloyName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
    sorter: (a, b) => {
      const descA = a.temperName || '';
      const descB = b.temperName || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Wt/R',
    dataIndex: 'weightRange',
    key: 'weightRange',
    sorter: (a, b) => {
      const descA = a.weightRange || '';
      const descB = b.weightRange || '';
      return descA.localeCompare(descB);
    },
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => {
      const descA = a.length ?? 0;
      const descB = b.length ?? 0;
      return descA - descB;
    },
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
   //     {
// //       title: 'Length',
// //       dataIndex: 'length',
// //       key: 'length',
// //     },
// //     {
// //   title: 'Unit',
// //   dataIndex: 'unit',
// //   key: 'unit',
// //   render: (unit) => {
// //     const unitOption = goodTypesOptions.find((opt) => opt.value === String(unit));
// //     return unitOption ? unitOption.label : '';
// //   },
// // }
// // ,
  {
    title: 'Pcs',
    dataIndex: 'pcs',
    key: 'pcs',
    sorter: (a, b) => {
      const descA = a.pcs ?? 0;
      const descB = b.pcs ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Qty',
    dataIndex: 'netWeight',
    key: 'netWeight',
    sorter: (a, b) => {
      const descA = a.netWeight ?? 0;
      const descB = b.netWeight ?? 0;
      return descA - descB;
    },
  },
  {
    title: 'Packing Id',
    dataIndex: 'packingId',
    key: 'packingId',
    sorter: (a, b) => {
      const descA = a.packingId || '';
      const descB = b.packingId || '';
      return descA.localeCompare(descB);
    },
  },
    {
      title: '',
      key: 'selection',
      render: (text, record) => (
        <Checkbox
          checked={selectedItemIds1.includes(record.packingId)}
          onChange={(e) => {
            const checked = e.target.checked
            setSelectedItemIds1((prev) =>
              checked
                ? [...prev, record.packingId]
                : prev.filter((id) => id !== record.packingId),
            )
          }}
        />
      ),
    },
  ]

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023e7d',
            color: '#fff',
            padding: '10px',
            fontSize: '14px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize: '14px',
          }}
        >
          {children}
        </td>
      ),
    },
  }
  const components1 = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#2E2E2E',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize: '15px',
          }}
        >
          {children}
        </td>
      ),
    },
  }
  const handleProduction = async (orderNumberIds) => {
    try {
      const response = await axios.put(
        `${UpdateOrderAllotmentProductionStatus}?orderNumberIds=${orderNumberIds}&status=1`,
        {},
        commonHeaders,
      )
      console.log('Response', response)

      if (response.data === 'UPDATED') {
        handleSubmitOrder(selectedId)
        fetchOrderAllotmentData()
        toast.success('Sent to Production Successfully')
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Already Sent to Production !')
      }
    } catch (error) {
      console.error('Production error:', error)
      toast.error('Failed to send to production.')
    }
  }
  //      const handleCheckboxChange = (packingId) => {
  //   let updatedSelectedRowKeys;
  //   if (selectedRowKeys.includes(packingId)) {
  //     updatedSelectedRowKeys = selectedRowKeys.filter((id) => id !== packingId);
  //   } else {
  //     updatedSelectedRowKeys = [...selectedRowKeys, packingId];
  //   }
  //   setSelectedRowKeys(updatedSelectedRowKeys);
  // };
  const handleAllocation = async (orderNumberIds) => {
    try {
      const response = await axios.put(
        UpdateOrderAllotmentAllocationStatus,
        orderNumberIds,
        commonHeaders,
      )
      console.log('Response', response)

      if (response.data === 'UPDATED') {
        handleSubmitOrder(selectedId)
        fetchOrderAllotmentData()
        toast.success('Allocated Successfully')
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Already Allocated !')
      }
    } catch (error) {
      console.error('Production error:', error)
      toast.error('Failed to send to production.')
    }
  }

 const [isModalVisible, setIsModalVisible] = useState(false);
const [pendingProductionIds, setPendingProductionIds] = useState([]);

const showConfirmationModal = (itemIds) => {
  setPendingProductionIds(itemIds);
  setIsModalVisible(true);
};


  const handleSubmitOrder = async (orderId) => {
    const order = allOrders.find((o) => o.id === orderId)
    setSelectedOrder(order)
    console.log(selectedOrder)
    let isValid = true
    const errorObj = {}

    // Validation: Ensure selectedId is present and valid
    if (!selectedId || (typeof selectedId === 'string' && !selectedId.trim())) {
      isValid = false
      errorObj.orderId = 'Order ID is required *'
    }

    setErrors(errorObj) // Set error messages
    if (!isValid) return

    try {
      // API Call: Fetch order details using selected ID
      const response = await axios.get(
        `${GetOrderAllotmentListById}?orderNumberId=${orderId}`,
        commonHeaders,
      )

      const orderDetails = response.data

      if (!orderDetails) {
        toast.error('Failed to fetch order details.')
        return
      }

      console.log('Order details fetched successfully:', orderDetails)

      // You can now process or submit the orderDetails further
      if (Array.isArray(orderDetails) && orderDetails.length > 0) {
        setOrderItems(orderDetails)
        setFilteredData(orderDetails)
        setTotalEntries(orderDetails.length)
        console.log('Order submitted successfully!')
         window.open(`#/orderallotment-details/${orderId}`, "_blank");
      } else {
        toast.warn('No items found for the selected order.')
        setOrderItems([]) // Clear order items
        setFilteredData([]) // Clear filtered data (this will reset the table display)
        setTotalEntries(0) // Reset total entries count
      }
    } catch (error) {
      console.error('Error during order submission:', error)
      toast.error('An error occurred while processing the order.')
    }
  }
  const fetchAllocatedBumdles = async () => {

    try {
      // API Call: Fetch order details using selected ID
      // const response = await axios.get(
      //   `${GetOrderAllotmentAllocatedBundles}?dieNameId=${record.dieNameId}`,
      //   commonHeaders
      // );
      const response = await axios.get(
       ` ${GetOrderAllotmentAllAllocatedData}?customerId=${selectedOrder.customerId}`,
        commonHeaders,
      )

      const orderDetails = response.data

      if (!orderDetails) {
        toast.error('Failed to allocated Bundle Details.')
        return
      }

      console.log('Order details fetched successfully:', orderDetails)

      // You can now process or submit the orderDetails further
      if (Array.isArray(orderDetails) && orderDetails.length > 0) {
        setAllocated(orderDetails)
        setDetailView(true)
        // setSelectedAllocationItem(record);
        // setFilteredData(orderDetails);
        // setTotalEntries(orderDetails.length);
        console.log('Order submitted successfully!')
      } else {
        toast.warn('No stock Allocated for the selected item.')
        setAllocated([]) // Clear order items
        // setFilteredData([]);  // Clear filtered data (this will reset the table display)
        // setTotalEntries(0);  // Reset total entries count
      }
    } catch (error) {
      console.error('Error during order submission:', error)
      toast.error('An error occurred while processing .')
    }
  }
  const fetchStock = async (record) => {
    try {
      const { dieNameId } = record

      // First: Fetch Stock Data
      const stockRes = await axios.get(
        `${GetOrderAllotmentStock}?dieNameId=${dieNameId}&alloyId=${record.alloyId}&temperId=${record.temperId}`,
        commonHeaders,
      )

      const stockData = stockRes.data || []

      if (stockData.length > 0) {
        setStockData(stockData)
        setSelectedOrderItem(record)
        setSelectedAllocationItem(record)
        setAllocateBack(true)
        setDetailView(false)

        // Now fetch allocated data only if stock exists
        const allocatedRes = await axios.get(
          `${GetOrderAllotmentAllocatedBundles}?dieNameId=${dieNameId}&customerId=${record.customerId}&alloyId=${record.alloyId}&temperId=${record.temperId}`,
          commonHeaders,
        )

        const allocatedData = allocatedRes.data || []
        setAllocatedStock(allocatedData)

        if (allocatedData.length === 0) {
          toast.warn('No stock allocated for the selected item.')
        }
      } else {
        toast.warn('No stock available for the selected item.')
        setStockData([])
        setDetailView(false)
      }
    } catch (error) {
      console.error('Error during stock fetch:', error)
      toast.error('An error occurred while processing.')
    }
  }
//========================= To group on the basis of die name ======================================================
  const groupedDataByDieName = allocated.reduce((acc, item) => {
    const key = item.dieName?.trim() // normalize key
    if (!acc[key]) acc[key] = []
    acc[key].push(item)
    return acc
  }, {})
//=================================================== To change color black or white ===========================================
// Function to calculate luminance of a color
const calculateLuminance = (color) => {
  // Remove the '#' from the hex code
  color = color.slice(1);

  // Convert hex to RGB
  let r = parseInt(color.substr(0, 2), 16) / 255;
  let g = parseInt(color.substr(2, 2), 16) / 255;
  let b = parseInt(color.substr(4, 2), 16) / 255;

  // Apply the luminance formula
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance;
};

// Function to determine text color (black or white)
const getTextColor = (bgColor) => {
  const luminance = calculateLuminance(bgColor);
  return luminance > 0.5 ? '#000' : '#FFF';  // If luminance is high, use black text, else white
};
//=============================================================================================================================================





  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
      <div
        className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
        style={{ backgroundColor: '#e0efff', minHeight: '800px' }}
      >
        <div className="col-12">
          <div className="container-fluid px-md-5 mt-3 p-2">
            <div className="row p-0 m-0">
              <div className="col-12 col-lg-4"></div>
              <div className="row justify-content-center">
                <div className="col-12 col-lg-6">
                  <div className="row p-0 m-0">
                    {/* {!selectedOrder && ( */}
                      <div className="col-12 py-1">
                        <label className="labels">Select Order</label>
                        <Select
                          showSearch
                          placeholder="Select an Order"
                          value={selectedId}
                        onChange={(value) => {
                 setSelectedId(value);
                }}
                          style={{ width: '100%' }}
                          optionFilterProp="children"
                        >
                          {/* {allOrders.map((order) => (
            <Option key={order.id} value={order.id}>
            {order.status === 0 ? (
        <span style={{ color: "red", fontWeight: "bold" }}>🔴</span>
      ) : <span></span>}
              {order.orderNumber} | {order.customerName} | {order.entryDate} |{" "}
              {order.poNumber} | {order.poDate}
            </Option>
          ))} */}
                          {[...allOrders]
                            .sort((a, b) => {
                              if (
                                a.allotmentStatus === 0 &&
                                b.allotmentStatus !== 0
                              )
                                return -1
                              if (
                                a.allotmentStatus !== 0 &&
                                b.allotmentStatus === 0
                              )
                                return 1

                              // Helper: convert 'dd/mm/yyyy' to Date object
                              const parseDMY = (dateStr) => {
                                {/* const [day, month, year] = dateStr.split('/')
                                return new Date(`${year}-${month}-${day}`)
                              } */}
  if (!dateStr || typeof dateStr !== 'string') return new Date(0); // safe fallback
    const [day, month, year] = dateStr.split('/');
    return new Date(`${year}-${month}-${day}`);
  };
                              const today = new Date()
                              const aDate = parseDMY(a.entryDate)
                              const bDate = parseDMY(b.entryDate)

                              const isAToday =
                                aDate.toDateString() === today.toDateString()
                              const isBToday =
                                bDate.toDateString() === today.toDateString()

                              if (isAToday && !isBToday) return -1
                              if (!isAToday && isBToday) return 1

                              if (
                                a.allotmentStatus === 0 &&
                                b.allotmentStatus !== 0
                              )
                                return -1
                              if (
                                a.allotmentStatus !== 0 &&
                                b.allotmentStatus === 0
                              )
                                return 1

                              // fallback: newest first
                              return bDate - aDate
                            })

                            .map((order) => {
                              const labelText = `${order.orderNumber} | ${order.customerName} | ${order.entryDate} | ${order.poNumber} | ${order.poDate}`
                              return (
                                <Option
                                  key={order.id}
                                  value={order.id}
                                  label={labelText}
                                >
                                  {order.allotmentStatus === 0 ? (
                                    <span
                                      style={{
                                        color: 'red',
                                        fontWeight: 'bold',
                                      }}
                                    >
                                      🔴{' '}
                                    </span>
                                  ) : (
                                    <span> </span>
                                  )}
                                  {labelText}
                                </Option>
                              )
                            })}
                        </Select>

                        <div className="mt-2 text-center">
                          <Button
                            type="submit"
                            className="SubmitBtn mx-1"
                            onClick={() => {
                              handleSubmitOrder(selectedId)
                              // handleOrder(selectedId);
                            }}
                          >
                            Submit Selected Order
                          </Button>
                        </div>
                      </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4"></div>
            </div>

            {/* {selectedOrder && (
              <>
                {/* Order Header Details 
 
<div className="shadow border p-4 mb-4" style={{ backgroundColor: '#f8f9fa', fontSize: '17px' }}>
  <div className="order-summary my-3 px-2">
    <h6 className="mb-3" style={{ fontSize: '17px' }}>Order Details:</h6>
    <div className="container-fluid">
      <div className="row">

        {/* Column 1 
        <div className="col-md-4">
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Order Number:</span>
            <strong>{selectedOrder.orderNumber}</strong>
          </div>
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Order Entry Date:</span>
            <strong>{selectedOrder.entryDate}</strong>
          </div>
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>PO Date:</span>
            <strong>{selectedOrder.poDate}</strong>
          </div>
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Customer Instruction:</span>
            <strong>{selectedOrder.customerInstruction || '-'}</strong>
          </div>
        </div>

        {/* Column 2 
        <div className="col-md-4">
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Customer Name:</span>
            <strong>{selectedOrder.customerName}</strong>
          </div>
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Pending Qty:</span>
            <strong>{selectedOrder.pendingQty} Kgs</strong>
          </div>
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Total Qty:</span>
            <strong>{selectedOrder.totalQty} Kgs</strong>
          </div>
        </div>

        {/* Column 3 
        <div className="col-md-4">
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Ready Qty:</span>
            <strong>{selectedOrder.readyQty} Kgs</strong>
          </div>
          <div className="d-flex mb-2">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Dispatch:</span>
            <strong>{selectedOrder.dispatchQty} Kgs</strong>
          </div>
          <div className="d-flex mb-2 align-items-center">
            <span style={{ minWidth: '130px', marginRight: '10px' }}>Colour Code:</span>
            <div
              style={{
                display: 'inline-block',
                backgroundColor: selectedOrder.colorHash,
                padding: '5px 10px',
                borderRadius: '4px',
                color: getTextColor(selectedOrder.colorHash),
              }}
            >
              {selectedOrder.orderNumber} ({selectedOrder.stickerCode})
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
 */}



                {/* <div className="mt-4">
  <div className="row">
    {/* Conditionally render single or two-column layout 
    <div className={selectedAllocationItem ? "col-md-6" : "col-md-12"}>
    {/* <div className= "col-md-6"> 

      <h6>Order Items</h6>
      <Table
        dataSource={orderItems}
        columns={orderItemColumns}
        pagination={false}
        bordered
        rowKey={(record) => record.id}
        components={components}
        scroll={{ x: true }}
      />
    </div>

    {/* Conditionally render Available Stock table 
    {selectedAllocationItem && (
      <div className="col-md-6">
        <h6>Available Stock for: {selectedAllocationItem.dieName}</h6>
        <Table
  dataSource={stockData.filter(
    (stock) => stock.dieName === selectedAllocationItem?.dieName
  )}
  columns={stockColumns}
  pagination={false}
  bordered
  rowKey={(record) => record.stockId}
  components={components}
  scroll={{ x: true }}
/>

      </div>
    )}
  </div>
 {/* Send to Production Button 
 {selectedItemIds.length > 1 && (
    <div className="text-center px-md-5 mb-3">
      <Button
        type="primary"
        onClick={() => handleProduction(selectedItemIds)}
        style={{ marginTop: "10px" }}
      >
        Send to Production
      </Button>
    </div>
  )}
  */}

                {/* <div className="mt-4">
  <div className="row">
    {!detailView &&!selectedAllocationItem ? (
      // ===== Show Order Items Table =====
      <div className="col-md-12">
        <h6>Order Items</h6>
        <Table
          dataSource={orderItems}
          columns={orderItemColumns}
          pagination={false}
          bordered
          rowKey={(record) => record.id}
          components={components}
          scroll={{ x: true }}
        />
      </div>
    ) : (
      // ===== Show Allocation View =====
      <div className="col-md-12">
        {/* Top Section: Selected Item Details 
        <div className="d-flex justify-content-between align-items-center">
          <h5>Item Name:<b> {selectedAllocationItem.dieName}</b></h5>
          <Button type="primary" onClick={() => setSelectedAllocationItem(null)}>
            Back
          </Button>
        </div>

        <Table
          dataSource={[selectedAllocationItem]}
          columns={[
            
             {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Item Entry Date",
      dataIndex: "itemEntryDate",
      key: "itemEntryDate",
      render: (date) => {
        if (!date) return "-";
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      },
    },
    {
      title: "Item Name",
      dataIndex: "dieName",
      key: "dieName",
    },
    // {
    //   title: "Item Details",
    //   key: "alloyTemper",
    //   render: (_, record) => (
    //     <div>
    //       <div><strong>Alloy:</strong> {record.alloyname}</div>
    //       <div><strong>Temper:</strong> {record.temperName}</div>
    //       <div><strong>Length:</strong> {record.length}</div>
    //       <div><strong>Weight:</strong> {record.weight}</div>
    //       <div><strong>Pcs:</strong> {record.pcs}</div>
    //       <div><strong>Quantity:</strong> {record.qty}</div>
    //     </div>
    //   ),
    // },
   
    {
      title: "Alloy",
      dataIndex: "alloyname",
      key: "alloyname",
    },
    {
      title: "Temp",
      dataIndex: "temperName",
      key: "temperName",
    },
    {
      title: "Wt/R",
      dataIndex: "weight",
      key: "weight",
    },
    {
      title: "Length",
      dataIndex: "length",
      key: "length",
    },
    {
      title: "Pcs",
      dataIndex: "pcs",
      key: "pcs",
    },
    {
      title: "Qty",
      dataIndex: "qty",
      key: "qty",
    },
   
    {
      title: "Prod. Status",
      dataIndex: "sendToProduction",
      key: "sendToProduction",
    },
    {
      title: "Allocated Pcs",
      dataIndex: "allocatedPcs",
      key: "allocatedPcs",
    },
    {
      title: "Allocated Qty",
      dataIndex: "allocatedQty",
      key: "allocatedQty",
    },
    {
      title: "Prod. Pcs",
      dataIndex: "productionPcs",
      key: "productionPcs",
    },
    {
      title: "Prod. Qty",
      dataIndex: "productionQty",
      key: "productionQty",
    },

            // Add more item detail columns here
          ]}
          components={components1}
          pagination={false}
          bordered
          rowKey={(record) => record.id}
          scroll={{ x: true }}
        />

        {/* Bottom Section: Stock Tables 
        <div className="row mt-4">
          {/* Available Stock 
          <div className="col-md-6">
            <h6>Available Stock</h6>
            <Table
              dataSource={stockData.filter(
                (stock) => stock.dieName === selectedAllocationItem?.dieName
              )}
              columns={stockColumns}
              pagination={false}
              components={components}
              bordered
              rowKey={(record) => record.stockId}
              scroll={{ x: true }}
            />
          </div>

          {/* Allocated Stock 
          <div className="col-md-6">
            <h6>Allocated Stock</h6>
            <Table
              dataSource={allocatedStock.filter(
                (item) => item.orderItemId === selectedAllocationItem?.id
              )}
              columns={allocatedColumns}
              components={components}
              pagination={false}
              bordered
              rowKey={(record) => record.id}
              scroll={{ x: true }}
            />
          </div>
        </div>
      </div>
    )}
  </div>

  {/* Send to Production Button 
  {selectedItemIds.length > 1 && !selectedAllocationItem && (
    <div className="text-center px-md-5 mb-3">
      <Button
        type="primary"
        onClick={() => handleProduction(selectedItemIds)}
        style={{ marginTop: "10px" }}
      >
        Send to Production
      </Button>
    </div>
  )}
</div> */}
{/* 
                <div className="mt-4">
                  <div className="row">
                    {!detailView && !selectedAllocationItem ? (
                      // ===== Show Full Order Items Table =====
                      <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center">
                          <h6>Order Items</h6>
                          <Button
                            type="primary"
                            style={{ fontSize: '15px' , marginBottom :"2%" }}
                            onClick={() => {
                              fetchAllocatedBumdles()
                            }}
                          >
                            Detail View
                          </Button>
                        </div>

                        <Table
                          dataSource={orderItems}
                          columns={orderItemColumns}
                          pagination={false}
                          bordered
                          rowKey={(record) => record.id}
                          components={components}
                          scroll={{ x: true }}
                        />
                      </div>
                    ) : (
                      !detailView && (
                        // ===== Allocation View (With Stock + Allocated) =====
                        <div className="col-md-12">
                          {/* Top Section: Selected Item Details 
                          <div className="d-flex justify-content-between align-items-center">
                            <h5>
                              Item Name: <b>{selectedAllocationItem.dieName}</b>
                            </h5>
                            <Button
                              type="primary"
                                                          style={{ fontSize: '15px' , marginBottom :"2%" }}

                              onClick={() => {
                                setSelectedAllocationItem(null)
                                setAllocateBack(false)
                                setDetailView(false)
                              }}
                            >
                              Back
                            </Button>
                          </div>

                          {/* Selected Item Table 
                          <Table
                            dataSource={[selectedAllocationItem]}
                            columns={[
                              {
                                title: 'Sr.No.',
                                dataIndex: '',
                                key: 'index',
                                render: (text, record, index) => index + 1,
                              },
                              {
                                title: 'Item Entry Date',
                                dataIndex: 'itemEntryDate',
                                key: 'itemEntryDate',
                                render: (date) => {
                                  if (!date) return '-'
                                  const [year, month, day] = date.split('-')
                                  return `${day}/${month}/${year}`
                                },
                              },
                              {
                                title: 'Item Name',
                                dataIndex: 'dieName',
                                key: 'dieName',
                              },
                              {
                                title: 'Alloy',
                                dataIndex: 'alloyname',
                                key: 'alloyname',
                              },
                              {
                                title: 'Temp',
                                dataIndex: 'temperName',
                                key: 'temperName',
                              },
                              {
                                title: 'Wt/R',
                                dataIndex: 'weight',
                                key: 'weight',
                              },
//                              
 {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },


                              { title: 'Pcs', dataIndex: 'pcs', key: 'pcs' },
                              { title: 'Qty', dataIndex: 'qty', key: 'qty' },
                                    {
      title: 'Pend.  Pcs',
      dataIndex: 'pendingOrderPcs',
      key: 'pendingOrderPcs',
    },
    {
      title: 'Pend. Qty',
      dataIndex: 'pendingOrderQty',
      key: 'pendingOrderQty',
    },
                            
                              {
                                title: 'Allo. Pcs',
                                dataIndex: 'allocatedPcs',
                                key: 'allocatedPcs',
                              },
                              {
                                title: 'Allo. Qty',
                                dataIndex: 'allocatedQty',
                                key: 'allocatedQty',
                              },
                              {
                                title: 'Prod. Pcs',
                                dataIndex: 'productionPcs',
                                key: 'productionPcs',
                              },
                              {
                                title: 'Prod. Qty',
                                dataIndex: 'productionQty',
                                key: 'productionQty',
                              },
                                {
                                title: 'Prod. Status',
                                dataIndex: 'sendToProduction',
                                key: 'sendToProduction',
                              },
                          
                            ]}
                            components={components1}
                            pagination={false}
                            bordered
                            rowKey={(record) => record.id}
                            scroll={{ x: true }}
                          />

                          {/* Stock + Allocated Stock Tables 
                          <div className="row mt-4">
                            <div className="col-md-12">
                              <h6>Available Stock</h6>
                              <Table
                                // dataSource={stockData.filter(
                                //   (stock) => stock.dieName === selectedAllocationItem?.dieName
                                // )}
                                dataSource={stockData}
                                columns={stockColumns}
                                pagination={false}
                                components={components}
                                bordered
                                rowKey={(record) => record.packingId}
                                scroll={{ x: true }}
                              />
                                <div className="d-flex justify-content-center mt-3">
                            <Button
                              type="primary"
                              className="UpdateBtn"
                              style={{color:"white"}}
  onClick={() => handleAllocation(selectedItemIds1)}
>
  Allocate
</Button>
</div>
                            </div>
                            <div className="col-md-12">
                              <h6>Allocated Stock</h6>
                              <Table
                                // dataSource={allocatedStock.filter(
                                //   (item) => item.orderItemId === selectedAllocationItem?.id
                                // )}
                                dataSource={allocatedStock}
                                columns={allocatedColumns}
                                components={components}
                                pagination={false}
                                bordered
                                rowKey={(record) => record.id}
                                scroll={{ x: true }}
                              />
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>

                  {/* Send to Production Button 
                  {selectedItemIds.length > 1 && !selectedAllocationItem && !detailView && (
                    <div className="text-center px-md-5 mb-3">
                      <Button
        type="primary"
        onClick={() => handleProduction(selectedItemIds)}
        style={{ marginTop: "10px" }}
      >
        Send to Production
      </Button> */}
                      {/* <Button
  type="primary"
  onClick={() => showConfirmationModal(selectedItemIds)} // pass multiple IDs
  style={{ marginTop: "10px" }}
>
  Send to Production
</Button> */}

                    {/* </div>
                  )} 
                </div>*/}

                {/* {detailView && (
                  <div className="col-md-12">
                    {/* Show Back button only once 
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div></div>
                      <Button
                        type="primary"
style={{ fontSize: '15px' , marginBottom :"2%" }}

                        onClick={() => {
                          setSelectedAllocationItem(null)
                          setAllocateBack(false)
                          setDetailView(false)
                        }}
                      >
                        Back
                      </Button>
                    </div>

                    {/* Now map over orderItems 
                    {orderItems.map((orderItem, index) => {
                      const dieName = orderItem.dieName?.trim()
                      const allocatedItems = groupedDataByDieName[dieName] || []

                      return (
                        <div key={`${dieName}_${index}`} className="mb-4">
                          <h6 className="text-center mb-3">
                            Allocated Stock for: {dieName}
                          </h6>

                          <Table
                            dataSource={[orderItem]}
                               columns={[
                              {
                                title: 'Sr.No.',
                                dataIndex: '',
                                key: 'index',
                                render: (text, record, index) => index + 1,
                              },
                              {
                                title: 'Item Entry Date',
                                dataIndex: 'itemEntryDate',
                                key: 'itemEntryDate',
                                render: (date) => {
                                  if (!date) return '-'
                                  const [year, month, day] = date.split('-')
                                  return `${day}/${month}/${year}`
                                },
                              },
                              {
                                title: 'Item Name',
                                dataIndex: 'dieName',
                                key: 'dieName',
                              },
                              {
                                title: 'Alloy',
                                dataIndex: 'alloyname',
                                key: 'alloyname',
                              },
                              {
                                title: 'Temp',
                                dataIndex: 'temperName',
                                key: 'temperName',
                              },
                              {
                                title: 'Wt/R',
                                dataIndex: 'weight',
                                key: 'weight',
                              },
//                               {
//                                 title: 'Length',
//                                 dataIndex: 'length',
//                                 key: 'length',
//                               }, 
//                               {
//   title: 'Unit',
//   dataIndex: 'unit',
//   key: 'unit',
//   render: (unit) => {
//     const unitOption = goodTypesOptions.find((opt) => opt.value === String(unit));
//     return unitOption ? unitOption.label : '';
//   },
// }
// ,
 {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },


                              { title: 'Pcs', dataIndex: 'pcs', key: 'pcs' },
                              { title: 'Qty', dataIndex: 'qty', key: 'qty' },
                                    {
      title: 'Pend.  Pcs',
      dataIndex: 'pendingOrderPcs',
      key: 'pendingOrderPcs',
    },
    {
      title: 'Pend. Qty',
      dataIndex: 'pendingOrderQty',
      key: 'pendingOrderQty',
    },
                            
                              {
                                title: 'Allo. Pcs',
                                dataIndex: 'allocatedPcs',
                                key: 'allocatedPcs',
                              },
                              {
                                title: 'Allo. Qty',
                                dataIndex: 'allocatedQty',
                                key: 'allocatedQty',
                              },
                              {
                                title: 'Prod. Pcs',
                                dataIndex: 'productionPcs',
                                key: 'productionPcs',
                              },
                              {
                                title: 'Prod. Qty',
                                dataIndex: 'productionQty',
                                key: 'productionQty',
                              },
                                {
                                title: 'Prod. Status',
                                dataIndex: 'sendToProduction',
                                key: 'sendToProduction',
                              },
                          
                            ]}
                            pagination={false}
                            bordered
                               components={components1}
                            rowKey={(record) =>
                              record.orderNumber + '_' + record.dieName
                            }
                            scroll={{ x: true }}
                          />

                          <Table
                            className="mt-3"
                            dataSource={allocatedItems}
                            columns={allocatedColumns}
                            locale={{ emptyText: 'No allocated stock' }}
                            pagination={false}
                            bordered
                            rowKey={(record) => record.packingId}
                            components={components}
                            scroll={{ x: true }}
                          />
                        </div>
                      )
                    })}
                  </div>
                )}
<Modal
  title="Confirm Production"
  visible={isModalVisible}
  onCancel={() => setIsModalVisible(false)}
  footer={null}
  width={500}
>
  <p>Are you sure you want to send the selected order(s) to production?</p>

  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
    <Button onClick={() => setIsModalVisible(false)}>Cancel</Button>
    <Button
      type="primary"
      onClick={() => {
        handleProduction(pendingProductionIds);
        setIsModalVisible(false);
      }}
    >
      Yes, Send to Production
    </Button>
  </div>
</Modal>

                {!allocateBack && !detailView && (
                  <div className="text-center px-md-5 mb-3">
                    <Button
                      type="submit"
                      className="CancelBtn mx-1"
                       style={{ fontSize: '15px' , marginTop :"2%" }}

                      onClick={() => {
                        fetchOrderAllotmentData()
                        setSelectedOrder(null)
                        setOrderItems([])
                        setApprovedItems(new Set())
                        setSelectedItemIds([])

                        setSelectedOrderItem('')
                        setSelectedAllocationItem('')
                        setAllocateBack(false) // ← Add this line
                      }}
                    >
                      Back to Page
                    </Button>
                  </div>
                )}
              </>
            )} */}
          </div>
        </div>
      </div>
    
    </div>
  )
}

export default OrderAllotment
